$(document).delegate('[data-toggle="popup"]', 'click', function () {
    var $target = $($(this).attr('data-target'));

    if ($target.length) {

        $('html').addClass('is-ovf');
        $target.show();
        setTimeout(function () {
            $target.addClass('active');
        }, 100);

        $target.find('.btn--close').one('click', function () {
            $target.removeClass('active');
            $target.hide();
            $('html').removeClass('is-ovf');
            return false;
        });

    }

    return false;
});